module.exports = __webpack_public_path__ + "static/media/border.796881fc.png";